<template>
<div class="qq">
  <div class="index_top fcolumn">
    <div class="top_logos frow">
      <div class="top_logo">
        <img class="logo_img" :src="require('@/assets/images/index_04.png')" mode="widthFix">
      </div>
      <div class="top_right">
        <div class="top_name">桃江农商银行</div>
        <div class="top_e">TAOJIANG RURAL COMMERCIAL BANK</div>
      </div>
    </div>
    <div class="top_title">{{title}}</div>
  </div>
  
  <div class="title">报名成功!</div>
  <div class="result_download" @click="goto('./')">返回首页</div>

  <div class="index_bottom fcolumn">
    <div class="bottom_name">桃江农商银行</div>
    <div class="bottom_code">Copyright © 2022 桃江农商银行</div>
  </div>
  <canvas width="400" height="400" id="my" style="position: absolute;top: -1000px;"></canvas>
</div>
</template>

<script>
export default {
  name: 'End',
  data () {
    return {
      msg: '',
      searchvalue:'',
      bgzkz:require('../assets/images/zkz.png'),
      title:''
    }
  },
  methods:{
    goto(page){
        this.$router.push(page);
    },
    
  },
  mounted() {
    this.title = localStorage.getItem('title');
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .result_download{
    color:#940709;
    border:1px solid #940709;
    font-size:16px;
    min-width:100px;
    height:40px;
    line-height:38px;
    text-align: center;
    padding:0 20px;
    cursor: pointer;
    width:100px;
    margin:30px auto;
    border-radius:5px;
  }
  .index_top{
    width:100%;
    background: #940709;
    height:150px;
    margin-bottom:100px;
  }
  .top_logos{
    padding:10px 5%;
  }
  .top_logo{
    width:100px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .logo_img{
    width:69px;
    height:69px;
  }
  .top_right{
    color:white;
  }
  .top_name{
    height:40px;
    font-weight: bold;
    font-size:25px;
    line-height:40px;
    letter-spacing:10px;
  }
  .top_e{
    height:40px;
    font-size:10px;
    line-height:40px;
    margin-top:-5px;
  }
  .top_title{
    height:50px;
    background: #940709;
    color:white;
    font-weight: bold;
    font-size:23px;
    text-align: center;
    line-height:50px;
  }
 
  .title{
    color:#94070A;
    font-size:35px;
    width:100%;
    text-align: center;
  }
  
  .index_bottom{
    width:500px;
    height:40px;
    border-top:5px solid #E6E6E6;
    color:#999999;
    font-size:12px;
    position: fixed;
    bottom:0;
    padding:10px 0;
  }
  .bottom_name{
    height:20px;
    line-height:20px;
    text-align: center;
    font-weight: bold;
  }
  .bottom_code{
    height:25px;
    line-height:25px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/End.vue